import classNames from "classnames/bind";
import Link from "next/link";
import React from "react";

import { encodeImageUrl } from "@/utils/strings";

import { GiftCardProps } from "../../interfaces/gift-cards/gift-card-interface";
import Grid from "../layout/grid";
import styles from "./giftCardImageGrid.module.scss";

const cx = classNames.bind(styles);

export type Props = {
    giftCards: Array<GiftCardProps>;
};

export const GiftCardImageGrid: React.FC<Props> = ({ giftCards }) => {
    const giftCardGridItems = giftCards.map((giftCard) => {
        if (giftCard.code === "MACYS") {
            return;
        }

        const giftCardItemClassName = cx({
            [styles.image]: true,
            [styles.nbi]: giftCard.supplier === "NBI",
        });

        return (
            <Link
                key={giftCard.id}
                href={giftCard.links.self}
                prefetch={false}
                className={styles.link}
            >
                <div
                    className={giftCardItemClassName}
                    style={{ backgroundImage: `url(${encodeImageUrl(giftCard.imageUrl)})` }}
                />
            </Link>
        );
    });

    return <Grid fullWidth>{giftCardGridItems}</Grid>;
};
